import { User } from '../../Permissions/AuthenticatedUser.context'
import { getAlerts } from '../Alerts/alerts.actions'
import { getDxStatus, getDxUserAccess, getTeleoptiConfig, getTheme, setReady } from '../app.actions'
import { AppThunk } from '../app.reducer'
import { loginSuccess } from '../LegacyLogin/login.actions'

/**
 * Dispatches actions that the app depends on after the user has successfully been authenticated
 * @todo possibly short-term: move the imported actions into this file, related API functions into ./loginApi.ts, and the reducer into this directory
 * @todo long-term: replace Redux user state with React context (AuthenticatedUserContext already exists, but the use of user from Redux is unclear)
 * @param user The user that has just been authenticated
 */
export const completeAuthorization = (user: User): AppThunk => async dispatch => {
  dispatch(setReady(false))
  dispatch(loginSuccess(user))
  dispatch(getAlerts())
  dispatch(getDxStatus())
  if (user.tenantId !== -1) {
    dispatch(getTeleoptiConfig(user.tenantId))
    dispatch(getDxUserAccess())
  }
  await dispatch(getTheme())
  dispatch(setReady(true))
}
